const secureUuid = () => {
  const cryptoApi = window.crypto;
  if (cryptoApi?.randomUUID) return cryptoApi.randomUUID();
  if (!cryptoApi?.getRandomValues) throw new Error('Gerador seguro indisponível. Não foi possível enviar o pedido.');
  const bytes = cryptoApi.getRandomValues(new Uint8Array(16));
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;
  return [...bytes].map((value, index) => `${[4, 6, 8, 10].includes(index) ? '-' : ''}${value.toString(16).padStart(2, '0')}`).join('');
};

// Match the backend's material request fields and defaults; UI-only price/isQuote
// are excluded because the server recalculates them.
const materialPayload = (payload) => JSON.stringify({
  category: payload.category,
  subcategory: payload.subcategory,
  scheduledDate: payload.scheduledDate,
  address: {
    street: payload.address?.street || '', number: payload.address?.number || '',
    city: payload.address?.city || '', state: payload.address?.state || '',
    zip: payload.address?.zip || '',
  },
  notes: payload.notes || '',
  paymentMethod: payload.paymentMethod || 'pix',
  installments: Math.max(1, Math.min(12, parseInt(payload.installments, 10) || 1)),
});

export const createJobCreationAttempt = (createJob, generateKey = secureUuid) => {
  let attempt = null;
  let pending = null;

  return {
    submit(payload) {
      if (pending) return pending;
      const material = materialPayload(payload);
      if (!attempt || attempt.material !== material) {
        attempt = { material, key: generateKey() };
      }
      const key = attempt.key;
      pending = Promise.resolve().then(() => createJob(payload, key));
      const result = pending.then((response) => {
        attempt = null; // definitive success ends this logical attempt
        return response;
      }).finally(() => { pending = null; });
      pending = result;
      return result;
    },
    cancel() {
      if (pending) return false;
      attempt = null;
      return true;
    },
    isPending() { return !!pending; },
  };
};
